<div class="slice-container card flex justify-content-center">    
    <div class="scope-container card flex justify-content-center">
        <p-selectButton 
        [disabled]="showDetail"
        [options]="scopeOptions" 
        [(ngModel)]="scopeValue" 
        (onOptionClick)="onScopePhaseChange($event, 'scope')"
        optionLabel="label" 
        multiple="true"
        optionValue="value" 
        class="custom-select-button"/>
    </div>    
    <!-- <div class="phase-container card flex justify-content-center">
        <label for="slice">Phase</label>
        <p-selectButton 
        [options]="phaseOptions" 
        [(ngModel)]="phaseValue" 
        multiple="true"
        (onChange)="onScopePhaseChange($event, 'phase')"
        optionLabel="label" 
        optionValue="value" />
    </div> -->
</div>
<p-toast position="bottom-center" key="bc"/>
<div class="chart-container" [ngClass]="{
    'detailed': showDetail,
}">
    <p-chart #chart type="pie" [data]="results" [options]="chartOptions"></p-chart>
</div>
<div class="flex" *ngIf="!showDetail">
    <p-button [disabled]="!treeTableResults||!treeTableResults.length||isBusy" icon="pi pi-download" label="Export All" (click)="exportExcel()" class="exportButton all"/>
</div>
<p-treeTable #dt [value]="treeTableResults" *ngIf="!showDetail" [loading]="showLoader">
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of columns" [ngClass]="{'align-right': col.align === 'right'}">
                {{ col.label }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttRow]="rowNode">
            <td *ngFor="let col of columns; let index = index" (click)="showDetailedTable(col.field, rowData)" 
            [ngClass]="{
                'library-name': col.field === 'library_name' && rowNode.parent !== null, 
                'library-description': col.field === 'library_description',
                'align-right': col.align === 'right'}">
                <p-treeTableToggler [rowNode]="rowNode"*ngIf="index == 0"></p-treeTableToggler>
                <ng-container *ngIf="isNumber(rowData[col.field]); else notNumber">
                    {{ rowData[col.field] | number }}
                </ng-container>
                <ng-template #notNumber>
                    {{ rowData[col.field] == 0 ? "" : rowData[col.field] }}
                </ng-template>
            </td>
        </tr>
    </ng-template>
</p-treeTable>
<button pButton id="backButton" *ngIf="showDetail" (click)="backToSummary()">Back to Summary</button>
<div class="detail-table-container" *ngIf="showDetail">
    <app-detail-table [data]="detailTableData"></app-detail-table>
</div>